// Promotional offers configuration
export interface PromotionalOffer {
  saveTag: string;
  originalPrice: number;
  offerText: string;
}

export const PROMOTIONAL_OFFERS: Record<string, PromotionalOffer> = {
  'RapNet Gem Buyer': {
    saveTag: 'Save 50%',
    originalPrice: 600,
    offerText: 'Introductory Offer'
  }
};

// Mutually exclusive addon pairs configuration
export interface MutuallyExclusiveAddons {
  groupId: string;
  addons: string[];
  defaultSelected?: string;
}

export const MUTUALLY_EXCLUSIVE_ADDONS: MutuallyExclusiveAddons[] = [
  {
    groupId: 'price-list',
    addons: ['Rapaport Price List', 'Rapaport Price List Plus']
  }
];

// Helper function to get mutually exclusive group for an addon
export const getMutuallyExclusiveGroup = (addonName: string): MutuallyExclusiveAddons | null => {
  return MUTUALLY_EXCLUSIVE_ADDONS.find(group => group.addons.includes(addonName)) || null;
};

// Helper function to check if addon is part of a mutually exclusive group
export const isMutuallyExclusiveAddon = (addonName: string): boolean => {
  return getMutuallyExclusiveGroup(addonName) !== null;
};
